import { render, staticRenderFns } from "./IllustrationsSection.vue?vue&type=template&id=099ffa73"
import script from "./IllustrationsSection.vue?vue&type=script&lang=ts"
export * from "./IllustrationsSection.vue?vue&type=script&lang=ts"
import style0 from "./IllustrationsSection.vue?vue&type=style&index=0&id=099ffa73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports